import VueProgressBar from 'vue-progressbar'

export default {
    install(Vue, options) {

        const optionsDefaults = {
            color: 'rgb(143, 255, 199)',
            failedColor: 'red',
            thickness: '3px'
        }

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(VueProgressBar, options)

    }
}
